'use client';
import { useState } from 'react';
import { Button } from './ui/button';
import { PromptCard } from './prompt-card'; // Ensure correct import path
import type { Prompt2 } from '@/types/schema'; // Ensure correct import path

interface LoadMoreProps {
    fetchUrl: string; // URL for fetching more prompts
    totalCount: number; // Total number of prompts available
    initialCount: number; // Number of prompts already rendered by the server
  }
  
  const limit = 12; 
  
  export const LoadMore: React.FC<LoadMoreProps> = ({ fetchUrl, totalCount, initialCount }) => {
    const [additionalData, setAdditionalData] = useState<Prompt2[]>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1); 
    const hasMore = (initialCount + additionalData.length) < totalCount;
    const loadMoreData = async () => {
      if (!hasMore || loading) return;
  
      setLoading(true);
      try {
        const response = await fetch(`${fetchUrl}&page=${page + 1}&limit=${limit}`);
        if (!response.ok) throw new Error('Failed to fetch data');
  
        const newData = await response.json();
  
        if (newData.results && newData.results.length > 0) {
          setAdditionalData((prevData) => [...prevData, ...newData.results]);
          setPage((prevPage) => prevPage + 1);
        }
      } catch (error) {
        console.error('Error loading more prompts:', error);
      } finally {
        setLoading(false);
      }
    };
  
  return (
    <div className="mt-6">
      {additionalData.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {additionalData.map((prompt) => (
            <PromptCard key={prompt._id} prompt={prompt}/>
          ))}
        </div>
      )}
      {/* Load More Button and Loading State */}
      <div className="text-center mt-12">
        {hasMore ? (
          <Button onClick={loadMoreData} className="w-full max-w-[250px] mx-auto py-6 text-md" disabled={loading}>
            {loading ? 'Loading...' : 'Load More'}
          </Button>
        ) : (
          <span> </span>
        )}
      </div>
    </div>
  );
};
